import { render, staticRenderFns } from "./BenefitSetting.vue?vue&type=template&id=2af0fe0d&"
import script from "./BenefitSetting.vue?vue&type=script&lang=js&"
export * from "./BenefitSetting.vue?vue&type=script&lang=js&"
import style0 from "./BenefitSetting.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports